import { createAnswerSchemaWithMixins } from '../answerSchemaFields';
import {
  createQuestionSchemaWithMixins,
  questionAutoCommit,
  questionHasTimer,
  questionInstantStatistic,
  questionRequiresAnswer,
} from '../questionSchemaFields';
import { config } from './BinaryPoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionHasTimer,
    questionAutoCommit,
    questionRequiresAnswer,
    questionInstantStatistic,
  },
  answer: createAnswerSchemaWithMixins(),
  type: config.name,
});
